import axios from 'axios';
import API_BACKEND_URL from '@/API_URL/api_back_end.js';
import { collectClientDeviceInfo } from '@/utils/clientDeviceInfo';
import { setUser, clearUser } from '@/services/tokenStore';

class AuthService {
    async login(user) {
        let clientInfo = null;
        try {
            clientInfo = await collectClientDeviceInfo();
        } catch (err) {
            clientInfo = null;
        }

        const response = await axios.post(API_BACKEND_URL + 'login', {
            login: user.username,
            password: user.password,
            clientInfo,
        });

        if (response.data.token) {
            setUser(response.data);
        }
        return response.data;
    }

    logout() {
        clearUser();
    }
}

export default new AuthService();
